// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2ALrW","title":"BackImages_title__16Zsl","images":"BackImages_images__2S-zp"};